export default __webpack_public_path__ + "static/media/clo.751d3706.jpg";